import {
  OSSConfig
} from "./common";
import {
  saveAs
} from "file-saver";
const client = OSSConfig();
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
export function find(list: any[], f: any) {
  return list.filter(f)[0];
}

export function isObject(obj: any) {
  return obj !== null && typeof obj === "object";
}

export function isPromise(val: any) {
  return val && typeof val.then === "function";
}
//深拷贝
export function deepClone(source: any) {
  const targetObj: any = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
  for (let keys in source) {
    // 遍历目标
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === "object") {
        // 如果值是对象，就递归一下
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        // 如果不是，就直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

//提取域名
export function getHost(value: string) {
  let re = /^http(s)?:\/\/(.*?)\//;
  return re.exec(value) ![0];
}

//时间转换
export function dateFormat(fmt: string, date: Date) {
  date = new Date(date);
  var o: any = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

export function download(vue: any, url: string, name: string, type: string, params: object) {
  return vue
    .$axios({
      method: type ? type : "post",
      url: url,
      responseType: "blob",
      params: params
    })
    .then((res: any) => {
      const blob = new Blob([res.data]);
      saveAs(blob, name);
    });
}
export function downloadnew(vue: any, url: any, name: any, params: any) {
  return vue
    .$axios({
      method: "post",
      url: url,
      responseType: "blob",
      params: params
    })
    .then((res: any) => {
      const blob = new Blob([res.data]);
      saveAs(blob, name);
    });
}
export function downloadgoods(vue: any, url: any, name: any, params: any) {
  return vue
    .$axios({
      method: "get",
      url: url,
      responseType: "blob",
      params: params
    })
    .then((res: any) => {
      const blob = new Blob([res.data]);
      saveAs(blob, name);
    });
}
export function aliOSSHost() {
  return (
    "http://" + client.options.bucket + "." + client.options.endpoint.host + "/"
  );
}
// 日志下载
export function loadList(url:any,fileName:any) {
  // let fileName = url.substring(url.lastIndexOf('log/')).substr(4)
  // console.log(fileName);
  const xhr = new XMLHttpRequest();
  console.log(xhr);
  xhr.open('GET',url)
  xhr.responseType = 'blob'
  xhr.send()
  xhr.onload = function() {
    const fileBlob = xhr.response;
    console.log(fileBlob);
    const fileUrl = URL.createObjectURL(fileBlob)
    console.log(fileUrl);
    const elementA = document.createElement('a')
    elementA.setAttribute('href',fileUrl)
    elementA.innerHTML = '下载'
    // elementA.setAttribute('download','')
    elementA.download = fileName
    elementA.click()
  }
}